<div class="cb-destination-input-wrapper">
    <div class="cb-destination-input-container">
        <div class="cb-destination-input">
            <cb-input [(ngModel)]="locationName" [placeholder]="placeholder()" [label]="label()" [hint]="hint()"
                [info]="info()" [required]="required() || false" [isClickOnly]="true" [disabled]="isDisabled()"
                (inputClick)="openDestinationSelection()"></cb-input>
        </div>
        <div class="cb-destination-controls">
            <cb-button [disabled]="disabled()" size="sm" type="iconOnly" icon="cb-app-outline-location-03"
                hierarchy="primary" color="brand" (click)="openDestinationSelection()"></cb-button>
        </div>
    </div>
    @if(mapUrl()){
    <a href="{{mapUrl()}}" target="_blank">
        <div class="cb-destination-input-link">
            <cb-icon name="cb-base-outline-map"></cb-icon>
            <p>{{locationData()?.address || ("COMMON.OPEN_MAP" | translate)}}</p>
        </div>
    </a>
    }
</div>